import { WebIO } from "@gltf-transform/core";
import { ALL_EXTENSIONS } from "@gltf-transform/extensions";
import { metalRough } from "@gltf-transform/functions";

export const transformModelFile = async (file: File) => {
  try {
    const io = new WebIO().registerExtensions(ALL_EXTENSIONS);

    const document = await io.readBinary(new Uint8Array(await file.arrayBuffer()));

    const specularGlossinessExtensionUsed = document
      .getRoot()
      .listExtensionsUsed()
      .find(({ extensionName }) => extensionName === "KHR_materials_pbrSpecularGlossiness");

    if (specularGlossinessExtensionUsed) {
      await document.transform(metalRough());
      const binaryData = await io.writeBinary(document);

      return new File([binaryData as Uint8Array<ArrayBuffer>], file.name, { type: "model/gltf-binary" });
    }
  } catch (error) {
    console.warn("Failed to transform model file.", error);
  }

  return file;
};
